import { render, staticRenderFns } from "./allApp.vue?vue&type=template&id=221f1f0c&scoped=true&"
import script from "./allApp.vue?vue&type=script&lang=js&"
export * from "./allApp.vue?vue&type=script&lang=js&"
import style0 from "./allApp.vue?vue&type=style&index=0&id=221f1f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f1f0c",
  null
  
)

export default component.exports